export default __webpack_public_path__ + "static/media/1499.47eda510.png";